import { useFieldArray, useFormContext } from "react-hook-form";
import FormInput from "./form";
import type { FormGroupSerialized, SimpleNodeSerialized } from ".";
import GeneralInput from "./general";

const VariableInput = () => {
  const { control } = useFormContext<{
    data: FormGroupSerialized[];
    simple_nodes: SimpleNodeSerialized[];
  }>();

  const { fields } = useFieldArray({ control, name: "data", keyName: "key" });
  const { fields: simpleFields } = useFieldArray({
    control,
    name: "simple_nodes",
    keyName: "key",
  });

  return (
    <div className="p-4 flex flex-col gap-4">
      {fields.map((f) => {
        return (
          <FormInput
            key={f.key}
            formId={f.form_id}
            formName={f.form_name}
            fields={f.fields}
          />
        );
      })}
      {simpleFields.map((f) => {
        return <GeneralInput key={f.key} data={f} />;
      })}
    </div>
  );
};

export default VariableInput;
